Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = require('./constants');

var _bn = require('bn.js');

var _bn2 = _interopRequireDefault(_bn);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Format a number.
 *
 * | number    | format       | string     |
 * |-----------|--------------|------------|
 * | 1000.234  | '$0,0.00'    | Ξ1,000.23  |
 * | 1000.2    | '0,0[.]00 $' | 1,000.20 Ξ |
 * | 1001      | '$ 0,0[.]00' | Ξ 1,001    |
 * | -1000.234 | '($0,0)'     | (Ξ1,000)   |
 * | -1000.234 | '$0.00'      | -Ξ1000.23  |
 * | 1230974   | '($ 0.00 a)' | Ξ 1.23 m   |
 *
 * @param {String|Number|BN} number
 * @param {String} format the format see http://numeraljs.com for examples
 * @param {String} unit any custom unit/currencies, will replace the `$` sign
 * @param {Object} options
 *  {String} etherSymbol if unit is `ether` will use this symbol for the unit instead (Ξ by default)
 *  {String} locale a custom local (*en* by default)
 */
exports['default'] = function (number, format) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ether';
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _constants.DEFAULT_OPTIONS;

    var _DEFAULT_OPTIONS$opti = Object.assign({}, _constants.DEFAULT_OPTIONS, options),
        locale = _DEFAULT_OPTIONS$opti.locale,
        etherSymbol = _DEFAULT_OPTIONS$opti.etherSymbol;

    if (number instanceof _bn2['default']) {
        number = number.toString(10);
    }

    try {
        _numeral2['default'].localeData(locale);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('Couldn\'t find locale \'' + String(locale) + '\', if implemented in \'numeral-js\', you need to load it manually: require(\'numeral/locales/' + String(locale) + '\');');
        locale = _constants.DEFAULT_LOCALE;
    }

    var localeData = _numeral2['default'].localeData(locale);
    localeData.currency = Object.assign({}, localeData.currency, {
        symbol: unit.toLowerCase() === 'ether' ? etherSymbol : unit
    });
    _numeral2['default'].locale(locale);

    return (0, _numeral2['default'])(number).format(format);
};

module.exports = exports['default'];
//# sourceMappingURL=formatNumber.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ethtools/build/formatNumber.js
// module id = 4V0s
// module chunks = 0